import { ComponentStyleConfig } from '@chakra-ui/react';

const themeTooltipComponent: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'md',
    bgColor: 'components.tooltip.bgColor',
    color: 'shared.text.default'
  }
};

export default themeTooltipComponent;
